/**
 * New Render as a side sheet (RM-118), opened from the Render Jobs list via the
 * `?new=1` search param (see {@link useNewJobSheet}). Hosts the two-step
 * {@link NewJobFlow} (type tiles → parameter form); on successful submit the
 * form navigates to `/jobs?preview=<id>`, which drops `?new` and dismisses this
 * sheet. Rendered only while `open` so each open starts back at the tiles.
 */
import { useTranslation } from 'react-i18next'
import { NewJobFlow } from '../../pages/NewJob'
import { TESTID } from '../../lib/testids'
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../ui/sheet'

export function NewJobSheet({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  const { t } = useTranslation()
  return (
    <Sheet
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose()
      }}
    >
      <SheetContent side="right" data-testid={TESTID.newJobSheet}>
        <SheetHeader>
          <SheetTitle className="text-lg">{t('jobs.new.title')}</SheetTitle>
        </SheetHeader>
        <SheetBody>{open && <NewJobFlow />}</SheetBody>
      </SheetContent>
    </Sheet>
  )
}
